var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification"},[_c('i',{class:_vm.icon}),_c('strong',[_c('small',[_vm._v(" "+_vm._s(_vm.config.titulo)+" ")])]),_c('br'),_c('small',[_vm._v(_vm._s(_vm.config.texto)+" \n"+_vm._s(_vm.config.fecha))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1dcff7d6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/NotificacionConst.vue
// module id = 1530
// module chunks = 0